import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { CONTACT } from "@/data/content";

export default function FounderNote() {
  return (
    <section
      id="founder-note"
      data-testid="founder-note-section"
      className="border-b border-[#E4E7EC] bg-[#F9FAFB]"
    >
      <div className="mx-auto max-w-4xl px-5 py-20 md:px-8 md:py-24">
        <p className="overline mb-4">§ 08a — From the founder</p>
        <motion.blockquote
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="border-l-4 border-[#D92D20] pl-6 md:pl-8"
        >
          <p className="font-display text-2xl font-medium leading-snug tracking-tight text-[#101828] md:text-3xl">
            "Every shipment that lands in India passes through the exact same
            four-step protocol — whether it's a 2 kg semiconductor sample from
            Frankfurt or a 3-tonne pharma pallet from Amsterdam. That
            consistency is the entire business."
          </p>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-[#475467]">
            I started Custom Clearance Partner because global freight forwarders
            kept telling me the same thing: <em>"Indian customs is fine — it's
            our India partner that's the problem."</em> Missed calls,
            unpredictable turnaround, one-off invoices, no visibility per HAWB.
            We fixed each of those, one at a time, with an ops discipline
            forwarders can actually build a lane on.
          </p>
          <p className="mt-4 text-base leading-relaxed text-[#475467]">
            If any shipment falls short, my mobile number is written into every
            MSA. Escalate to me directly at{" "}
            <a href={CONTACT.telHref} className="font-semibold text-[#D92D20] underline">
              {CONTACT.phoneDisplay}
            </a>
            .
          </p>
          <footer className="mt-8 flex flex-col gap-4 border-t border-[#E4E7EC] pt-6 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <div className="font-display text-lg font-bold text-[#101828]">
                Jaisy Atharth
              </div>
              <div className="font-mono-accent text-[#475467]">
                FOUNDER · CUSTOM CLEARANCE PARTNER · GREATER NOIDA
              </div>
            </div>
            <div className="flex gap-2">
              <a
                href={CONTACT.whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="founder-whatsapp"
                className="inline-flex items-center gap-2 border-2 border-[#101828] bg-[#25D366] px-4 py-2.5 text-sm font-semibold text-[#0B111A] hover:bg-[#1FBE5A]"
              >
                <MessageCircle className="h-4 w-4" strokeWidth={2.5} /> WhatsApp me directly
              </a>
              <a
                href={CONTACT.telHref}
                data-testid="founder-call"
                className="inline-flex items-center gap-2 border-2 border-[#101828] bg-white px-4 py-2.5 text-sm font-semibold text-[#101828] hover:bg-[#101828] hover:text-white"
              >
                <Phone className="h-4 w-4" strokeWidth={2.5} />
              </a>
            </div>
          </footer>
        </motion.blockquote>
      </div>
    </section>
  );
}
